import { hRatio, wRatio } from "../constants/utils";

const Evolve = ({ height = 64, width = 256 }) => {
  return (
    <svg
      width={width * wRatio}
      height={height * hRatio}
      viewBox="0 0 256 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M156.916 60.3676C151.119 60.3676 146.377 55.757 146.377 50.0366V5.72436C146.377 2.82144 148.66 0.601562 151.646 0.601562C154.545 0.601562 156.828 2.90682 156.828 5.72436V50.0366L156.916 50.122C159.814 50.122 162.186 52.4272 162.186 55.2448C162.186 58.0623 159.814 60.3676 156.916 60.3676ZM20.9574 17.6775C32.8142 17.5921 42.4754 27.3254 42.0362 38.9371C41.8606 41.2424 40.8066 43.1207 37.4691 43.1207H10.5936C12.0867 47.3897 16.1268 50.5488 20.9574 50.378C23.9436 50.2073 26.5784 49.2681 28.7741 47.0482C30.7063 45.2552 33.956 45.2552 35.8004 47.1336C37.9083 49.1827 37.9083 52.2564 35.8004 54.1348C27.1054 62.5874 12.7015 62.6728 4.53348 52.0856C-6.5329 37.7418 4.09434 17.7629 20.9574 17.6775ZM20.9588 27.4977C16.6552 27.4977 13.0542 29.8883 11.2098 33.2181H30.7078C28.8634 29.8883 25.1746 27.4977 20.9588 27.4977ZM89.4564 22.7144C89.4564 19.9822 87.0851 17.6769 84.1867 17.6769C82.4302 17.6769 80.7614 18.5307 79.7953 19.8968L67.4993 43.8032L55.0277 19.8114C54.1494 18.5307 52.5685 17.6769 50.8998 17.6769C47.9136 17.6769 45.5422 19.9822 45.5422 22.7144C45.5422 24.4359 46.1761 25.6439 53.9158 40.3951L53.9169 40.3971L53.9198 40.4028L53.9234 40.4095C56.1627 44.6775 58.9964 50.0783 62.5809 56.9517C63.6349 59.0009 65.3914 60.3669 67.4993 60.3669C69.5194 60.3669 71.3638 59.1716 72.2421 57.464L88.7538 25.2758C88.7538 25.2758 89.4564 23.8243 89.4564 22.7144ZM210.406 22.7144C210.406 19.9822 208.035 17.6769 205.137 17.6769C203.38 17.6769 201.711 18.5307 200.745 19.8968L188.449 43.8032L175.978 19.8114C175.099 18.5307 173.518 17.6769 171.85 17.6769C168.863 17.6769 166.492 19.9822 166.492 22.7144C166.492 24.4358 167.126 25.6439 174.865 40.3939L174.865 40.3947L174.866 40.3951C177.106 44.6653 179.942 50.0706 183.531 56.9517C184.585 59.0009 186.341 60.3669 188.449 60.3669C190.469 60.3669 192.314 59.1716 193.192 57.464L209.704 25.2758C209.704 25.2758 210.406 23.8243 210.406 22.7144ZM234.907 17.6775C246.764 17.5921 256.425 27.3254 255.986 38.9371C255.81 41.2424 254.756 43.1207 251.419 43.1207H224.543C226.036 47.3897 230.076 50.5488 234.907 50.378C237.893 50.2073 240.528 49.2681 242.723 47.0482C244.656 45.2552 247.905 45.2552 249.75 47.1336C251.858 49.1827 251.858 52.2564 249.75 54.1348C241.055 62.5874 226.651 62.6728 218.483 52.0856C207.416 37.7418 218.044 17.7629 234.907 17.6775ZM225.159 33.2181C227.004 29.8883 230.605 27.4977 234.908 27.4977C239.124 27.4977 242.813 29.8883 244.657 33.2181H225.159Z"
        fill="#31496E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M95.4512 23.4906C95.4512 35.5604 105.171 45.3562 117.146 45.3562C129.122 45.3562 138.841 35.5604 138.841 23.4906C138.841 11.4208 129.122 1.625 117.146 1.625C105.171 1.625 95.4512 11.4208 95.4512 23.4906ZM128.424 23.4856C128.424 29.6955 123.304 34.8558 117.143 34.8558C110.982 34.8558 105.861 29.6955 105.861 23.4856C105.861 17.2758 110.982 12.1155 117.143 12.1155C123.304 12.1155 128.424 17.2758 128.424 23.4856Z"
        fill="#31496E"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M133.404 63.4804H101.246C98.2624 63.4804 95.9805 61.2317 95.9805 58.291C95.9805 55.4368 98.3502 53.1881 101.246 53.1881H107.489L107.489 53.1016L107.576 53.1881H117.213L117.301 53.1016L117.3 53.1881H133.404C136.301 53.1881 138.67 55.4368 138.67 58.291C138.67 61.2317 136.388 63.4804 133.404 63.4804Z"
        fill="#31496E"
      />
      <mask
        id="mask0_7039_8552"
        maskUnits="userSpaceOnUse"
        x="95"
        y="53"
        width="44"
        height="11"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M133.404 63.4804H101.246C98.2624 63.4804 95.9805 61.2317 95.9805 58.291C95.9805 55.4368 98.3502 53.1881 101.246 53.1881H107.489L107.489 53.1016L107.576 53.1881H117.213L117.301 53.1016L117.3 53.1881H133.404C136.301 53.1881 138.67 55.4368 138.67 58.291C138.67 61.2317 136.388 63.4804 133.404 63.4804Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_7039_8552)">
        <rect
          x="106.254"
          y="52.0938"
          width="12.5491"
          height="12.8278"
          fill="#31496E"
        />
      </g>
    </svg>
  );
};

export default Evolve;
